import React, { useState, useEffect } from 'react';
import Header from '../../components/partials/Header';
import { Container } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import '../../styles/login.css';
import { connect } from 'react-redux';
import axios from 'axios';

function Reset() {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [token, setToken] = useState('');
  const [errors, setErrors] = useState('');
  const [showModal, setShowModal] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const resetToken = query.get('token');
    setToken(resetToken);
  });

  const handleSubmit = event => {
    event.preventDefault();

    let user = {
      password: password,
      confirmPassword: confirmPassword,
      token: token,
    };

    if (password === confirmPassword) {
      axios
        .post('https://emaildrop.com/reset', { user }, {})
        .then(response => {
          setShowModal(true);
        })
        .catch(error => console.log('api errors:', error));
    } else if (!token) {
      setErrors('No reset token present. Please check you email.');
    } else {
      setErrors('Passwords do not match');
    }
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <div>
      <Container
        fluid
        className="form-container d-flex justify-content-center align-items-center "
      >
        <Form
          className="login-form shadow p-3 bg-white rounded"
          onSubmit={handleSubmit}
        >
          <h2 className="mb-3">Password Reset</h2>
          <Form.Group className="mb-3" controlId="formPassword">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter Password"
              onChange={e => {
                setPassword(e.target.value);
                setErrors('');
              }}
              value={password}
              name="password"
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formConfirmPassword">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Confirm Password"
              onChange={e => {
                setConfirmPassword(e.target.value);
                setErrors('');
              }}
              value={confirmPassword}
              name="confirmPassword"
            />
          </Form.Group>
          {errors && (
            <div className="errors">
              <p className="text-danger">{errors}</p>
            </div>
          )}
          <Button className="formButton" type="submit">
            Reset
          </Button>
        </Form>
      </Container>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Password Reset</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <a href="/login">Login</a>
        </Modal.Body>
      </Modal>
    </div>
  );
}
export default connect()(Reset);
